import { Navigate, Route } from 'react-router-dom'
import AuthLogin from 'publicPages/modules/AuthLogin'
import Logout from 'publicPages/modules/Logout'
import { lazy } from 'react'
import { LoginLayout } from 'publicPages/modules/LoginForm'
import LoginFormPassword from 'publicPages/modules/LoginFormPassword'

const Tracking = lazy(
    () =>
        import(
            /* webpackChunkName: 'Tracking' */ 'publicPages/modules/Tracking'
        )
)

const PublicAgentChat = lazy(
    () =>
        import(
            /* webpackChunkName: 'PublicAgentChat' */ 'publicPages/modules/PublicAgentChat'
        )
)

const Calendar = lazy(
    () =>
        import(
            /* webpackChunkName: 'Calendar' */ 'publicPages/modules/Calendar'
        )
)

export const PublicRoutes = () => {
    return (
        <>
            <Route
                path="/login"
                element={<Navigate to="/authLogin" replace />}
            />
            <Route path="/user/login" element={<LoginLayout />}>
                <Route index element={<LoginFormPassword />} />
            </Route>
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/authLogin" element={<AuthLogin />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/wilson" element={<PublicAgentChat />} />
            <Route path="/agents" element={<PublicAgentChat />} />
        </>
    )
}
